// src/components/Splash/Splash.js
import React, { useEffect, useState } from 'react';
import './Splash.css';
import ACMSplashLogo from './acm_splash_logo.png';

const MINIMUM_DISPLAY_TIME = 1500; // 1.5 seconds

const Splash = ({ children }) => {
  const [isSplashLoading, setIsSplashLoading] = useState(true);
  const [progress, setProgress] = useState(0);
  const [startTime] = useState(Date.now());

  useEffect(() => {
    let loadedCount = 0;
    let totalCount = 0;

    // Count all images and fonts to load
    const images = document.querySelectorAll('img');
    const fonts = document.fonts ? Array.from(document.fonts) : [];

    totalCount = images.length + fonts.length;

    // If no assets, just use minimum time
    if (totalCount === 0) {
      const timer = setTimeout(() => {
        setProgress(100);
        setTimeout(() => setIsSplashLoading(false), 300);
      }, MINIMUM_DISPLAY_TIME);
      return () => clearTimeout(timer);
    }

    // Track image load
    images.forEach((img) => {
      if (img.complete) {
        loadedCount++;
      } else {
        img.addEventListener('load', () => {
          loadedCount++;
          updateProgress(loadedCount, totalCount);
        });
        img.addEventListener('error', () => {
          loadedCount++;
          updateProgress(loadedCount, totalCount);
        });
      }
    });

    // Track font load
    if (document.fonts) {
      fonts.forEach((font) => {
        font.loaded.then(() => {
          loadedCount++;
          updateProgress(loadedCount, totalCount);
        }).catch(() => {
          loadedCount++;
          updateProgress(loadedCount, totalCount);
        });
      });
    }

    // Fallback: Ensure minimum time
    const minimumTimer = setTimeout(() => {
      if (progress < 100) {
        setProgress(100);
        setTimeout(() => setIsSplashLoading(false), 300);
      }
    }, MINIMUM_DISPLAY_TIME);

    function updateProgress(loaded, total) {
      const percent = Math.round((loaded / total) * 100);
      const elapsed = Date.now() - startTime;
      const remainingTime = Math.max(0, MINIMUM_DISPLAY_TIME - elapsed);
      const adjustedPercent = Math.min(percent, 100);

      setProgress(adjustedPercent);

      if (loaded >= total && remainingTime <= 0) {
        clearTimeout(minimumTimer);
        setTimeout(() => setIsSplashLoading(false), 300);
      }
    }

    // Cleanup
    return () => clearTimeout(minimumTimer);
  }, [startTime, progress]);

  return (
    <>
      {isSplashLoading ? (
        <div className="splash-overlay">
          <div className="splash-content">
            <img src={ACMSplashLogo} alt="DIET ACM Student Chapter" className="splash-logo" />
            
            {/* Real Progress Bar */}
            <div className="loading-bar-wrapper">
              <div
                className="loading-bar"
                style={{ width: `${progress}%` }}
              ></div>
            </div>

            <p className="loading-text">
              Loading Website Assets... <strong>{progress}%</strong>
            </p>
          </div>
        </div>
      ) : (
        children
      )}
    </>
  );
};

export default Splash;